var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _WorkOrderModel_company_id, _WorkOrderModel_asset_id, _WorkOrderModel_description, _WorkOrderModel_priority_cat, _WorkOrderModel_assigned_to, _WorkOrderModel_status_cat, _WorkOrderModel_created_by, _WorkOrderModel_created_at, _WorkOrderModel_updated_at, _WorkOrderModel_active_work_ms, _WorkOrderModel_current_started_at, _WorkOrderModel_completed_at, _WorkOrderModel_is_pm, _WorkOrderModel_pm_template_id, _WorkOrderModel_pm_due_at, _WorkOrderModel_pm_cycle_start_at, _WorkOrderModel_pm_cycle_id, _WorkOrderModel_grace_days, _WorkOrderModel_checklist, _WorkOrderModel_parts;
export var WorkOrderPriorityCat;
(function (WorkOrderPriorityCat) {
    WorkOrderPriorityCat[WorkOrderPriorityCat["LOW"] = 1] = "LOW";
    WorkOrderPriorityCat[WorkOrderPriorityCat["MEDIUM"] = 2] = "MEDIUM";
    WorkOrderPriorityCat[WorkOrderPriorityCat["HIGH"] = 3] = "HIGH";
    WorkOrderPriorityCat[WorkOrderPriorityCat["CRITICAL"] = 4] = "CRITICAL";
})(WorkOrderPriorityCat || (WorkOrderPriorityCat = {}));
export var WorkOrderStatusCat;
(function (WorkOrderStatusCat) {
    WorkOrderStatusCat[WorkOrderStatusCat["OPEN"] = 1] = "OPEN";
    WorkOrderStatusCat[WorkOrderStatusCat["IN_PROGRESS"] = 2] = "IN_PROGRESS";
    WorkOrderStatusCat[WorkOrderStatusCat["COMPLETED"] = 3] = "COMPLETED";
    WorkOrderStatusCat[WorkOrderStatusCat["AWAITING_PARTS"] = 4] = "AWAITING_PARTS";
})(WorkOrderStatusCat || (WorkOrderStatusCat = {}));
export class WorkOrderModel {
    constructor(data = {}) {
        _WorkOrderModel_company_id.set(this, void 0);
        _WorkOrderModel_asset_id.set(this, void 0);
        _WorkOrderModel_description.set(this, void 0);
        _WorkOrderModel_priority_cat.set(this, void 0);
        _WorkOrderModel_assigned_to.set(this, void 0);
        _WorkOrderModel_status_cat.set(this, void 0);
        _WorkOrderModel_created_by.set(this, void 0); // User who created the work order
        _WorkOrderModel_created_at.set(this, void 0);
        _WorkOrderModel_updated_at.set(this, void 0);
        _WorkOrderModel_active_work_ms.set(this, void 0);
        _WorkOrderModel_current_started_at.set(this, void 0);
        _WorkOrderModel_completed_at.set(this, void 0);
        // PM-specific fields
        _WorkOrderModel_is_pm.set(this, void 0);
        _WorkOrderModel_pm_template_id.set(this, void 0);
        _WorkOrderModel_pm_due_at.set(this, void 0);
        _WorkOrderModel_pm_cycle_start_at.set(this, void 0);
        _WorkOrderModel_pm_cycle_id.set(this, void 0);
        _WorkOrderModel_grace_days.set(this, void 0);
        // Snapshot of PM defaults
        _WorkOrderModel_checklist.set(this, void 0);
        _WorkOrderModel_parts.set(this, void 0);
        // Handle both old string values and new numeric values for backward compatibility
        let priority_cat = data.priority_cat || WorkOrderPriorityCat.MEDIUM;
        let status_cat = data.status_cat || WorkOrderStatusCat.OPEN;
        // Convert old string values to numeric if needed, but only if numeric values weren't provided
        if (data.priority && typeof data.priority === 'string' && !data.priority_cat) {
            priority_cat = this.convertPriorityStringToCat(data.priority);
        }
        if (data.status && typeof data.status === 'string' && !data.status_cat) {
            status_cat = this.convertStatusStringToCat(data.status);
        }
        this.company_id = data.company_id || '';
        this.asset_id = data.asset_id || '';
        this.description = data.description || '';
        this.priority_cat = priority_cat;
        this.assigned_to = data.assigned_to || '';
        this.status_cat = status_cat;
        this.created_by = data.created_by || '';
        this.created_at = data.created_at || Date.now();
        this.updated_at = data.updated_at || Date.now();
        this.active_work_ms = data?.active_work_ms ?? 0;
        this.current_started_at = data?.current_started_at ?? null;
        this.completed_at = data?.completed_at ?? null;
        // Initialize PM fields
        this.is_pm = data.is_pm || false;
        this.pm_template_id = data.pm_template_id || null;
        this.pm_due_at = data.pm_due_at || null;
        this.pm_cycle_start_at = data.pm_cycle_start_at || null;
        this.pm_cycle_id = data?.pm_cycle_id || null;
        this.grace_days = data?.grace_days ?? null;
        // Snapshots
        this.checklist = data?.checklist ?? [];
        this.parts = data?.parts ?? [];
    }
    // Getters and Setters
    get company_id() {
        return __classPrivateFieldGet(this, _WorkOrderModel_company_id, "f");
    }
    set company_id(company_id) {
        __classPrivateFieldSet(this, _WorkOrderModel_company_id, company_id, "f");
    }
    get asset_id() {
        return __classPrivateFieldGet(this, _WorkOrderModel_asset_id, "f");
    }
    set asset_id(asset_id) {
        __classPrivateFieldSet(this, _WorkOrderModel_asset_id, asset_id, "f");
    }
    get description() {
        return __classPrivateFieldGet(this, _WorkOrderModel_description, "f");
    }
    set description(description) {
        __classPrivateFieldSet(this, _WorkOrderModel_description, description, "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, Date.now(), "f");
    }
    get priority_cat() {
        return __classPrivateFieldGet(this, _WorkOrderModel_priority_cat, "f");
    }
    set priority_cat(priority_cat) {
        __classPrivateFieldSet(this, _WorkOrderModel_priority_cat, priority_cat, "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, Date.now(), "f");
    }
    // Getter for backward compatibility - converts numeric to string
    get priority() {
        return this.convertPriorityCatToString(__classPrivateFieldGet(this, _WorkOrderModel_priority_cat, "f"));
    }
    // Conversion methods
    convertPriorityStringToCat(priorityString) {
        const priorityMap = {
            'Low': WorkOrderPriorityCat.LOW,
            'Medium': WorkOrderPriorityCat.MEDIUM,
            'High': WorkOrderPriorityCat.HIGH,
            'Critical': WorkOrderPriorityCat.CRITICAL
        };
        return priorityMap[priorityString] || WorkOrderPriorityCat.MEDIUM;
    }
    convertPriorityCatToString(priorityCat) {
        const priorityMap = {
            [WorkOrderPriorityCat.LOW]: 'Low',
            [WorkOrderPriorityCat.MEDIUM]: 'Medium',
            [WorkOrderPriorityCat.HIGH]: 'High',
            [WorkOrderPriorityCat.CRITICAL]: 'Critical'
        };
        return priorityMap[priorityCat] || 'Medium';
    }
    get assigned_to() {
        return __classPrivateFieldGet(this, _WorkOrderModel_assigned_to, "f");
    }
    set assigned_to(assigned_to) {
        __classPrivateFieldSet(this, _WorkOrderModel_assigned_to, assigned_to, "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, Date.now(), "f");
    }
    get created_by() {
        return __classPrivateFieldGet(this, _WorkOrderModel_created_by, "f");
    }
    set created_by(created_by) {
        __classPrivateFieldSet(this, _WorkOrderModel_created_by, created_by, "f");
    }
    get status_cat() {
        return __classPrivateFieldGet(this, _WorkOrderModel_status_cat, "f");
    }
    set status_cat(status_cat) {
        __classPrivateFieldSet(this, _WorkOrderModel_status_cat, status_cat, "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, Date.now(), "f");
    }
    // Getter for backward compatibility - converts numeric to string
    get status() {
        return this.convertStatusCatToString(__classPrivateFieldGet(this, _WorkOrderModel_status_cat, "f"));
    }
    // Conversion methods
    convertStatusStringToCat(statusString) {
        const statusMap = {
            'Open': WorkOrderStatusCat.OPEN,
            'In Progress': WorkOrderStatusCat.IN_PROGRESS,
            'In_Progress': WorkOrderStatusCat.IN_PROGRESS,
            'Completed': WorkOrderStatusCat.COMPLETED,
            'Awaiting Parts': WorkOrderStatusCat.AWAITING_PARTS,
            'AWAITING_PARTS': WorkOrderStatusCat.AWAITING_PARTS
        };
        return statusMap[statusString] || WorkOrderStatusCat.OPEN;
    }
    convertStatusCatToString(statusCat) {
        const statusMap = {
            [WorkOrderStatusCat.OPEN]: 'Open',
            [WorkOrderStatusCat.IN_PROGRESS]: 'In Progress',
            [WorkOrderStatusCat.COMPLETED]: 'Completed',
            [WorkOrderStatusCat.AWAITING_PARTS]: 'Awaiting Parts'
        };
        return statusMap[statusCat] || 'Open';
    }
    get created_at() {
        return __classPrivateFieldGet(this, _WorkOrderModel_created_at, "f");
    }
    set created_at(created_at) {
        if (typeof created_at !== 'number') {
            throw new Error('Created at must be a valid number (Unix epoch timestamp)');
        }
        __classPrivateFieldSet(this, _WorkOrderModel_created_at, created_at, "f");
    }
    get updated_at() {
        return __classPrivateFieldGet(this, _WorkOrderModel_updated_at, "f");
    }
    set updated_at(updated_at) {
        if (typeof updated_at !== 'number') {
            throw new Error('Updated at must be a valid number (Unix epoch timestamp)');
        }
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, updated_at, "f");
    }
    // Timing-specific getters and setters
    get active_work_ms() {
        return __classPrivateFieldGet(this, _WorkOrderModel_active_work_ms, "f");
    }
    set active_work_ms(active_work_ms) {
        if (typeof active_work_ms !== 'number' || active_work_ms < 0) {
            throw new Error('active_work_ms must be a non-negative number');
        }
        __classPrivateFieldSet(this, _WorkOrderModel_active_work_ms, active_work_ms, "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, Date.now(), "f");
    }
    get current_started_at() {
        return __classPrivateFieldGet(this, _WorkOrderModel_current_started_at, "f");
    }
    set current_started_at(current_started_at) {
        if (current_started_at !== null && typeof current_started_at !== 'number') {
            throw new Error('current_started_at must be a valid number (Unix epoch timestamp) or null');
        }
        __classPrivateFieldSet(this, _WorkOrderModel_current_started_at, current_started_at, "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, Date.now(), "f");
    }
    get completed_at() {
        return __classPrivateFieldGet(this, _WorkOrderModel_completed_at, "f");
    }
    set completed_at(completed_at) {
        if (completed_at !== null && typeof completed_at !== 'number') {
            throw new Error('completed_at must be a valid number (Unix epoch timestamp) or null');
        }
        __classPrivateFieldSet(this, _WorkOrderModel_completed_at, completed_at, "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, Date.now(), "f");
    }
    // PM-specific getters and setters
    get is_pm() {
        return __classPrivateFieldGet(this, _WorkOrderModel_is_pm, "f");
    }
    set is_pm(is_pm) {
        __classPrivateFieldSet(this, _WorkOrderModel_is_pm, is_pm, "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, Date.now(), "f");
    }
    get pm_template_id() {
        return __classPrivateFieldGet(this, _WorkOrderModel_pm_template_id, "f");
    }
    set pm_template_id(pm_template_id) {
        __classPrivateFieldSet(this, _WorkOrderModel_pm_template_id, pm_template_id, "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, Date.now(), "f");
    }
    get pm_due_at() {
        return __classPrivateFieldGet(this, _WorkOrderModel_pm_due_at, "f");
    }
    set pm_due_at(pm_due_at) {
        if (pm_due_at !== null && typeof pm_due_at !== 'number') {
            throw new Error('PM due at must be a valid number (Unix epoch timestamp) or null');
        }
        __classPrivateFieldSet(this, _WorkOrderModel_pm_due_at, pm_due_at, "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, Date.now(), "f");
    }
    get pm_cycle_start_at() {
        return __classPrivateFieldGet(this, _WorkOrderModel_pm_cycle_start_at, "f");
    }
    set pm_cycle_start_at(pm_cycle_start_at) {
        if (pm_cycle_start_at !== null && typeof pm_cycle_start_at !== 'number') {
            throw new Error('PM cycle start at must be a valid number (Unix epoch timestamp) or null');
        }
        __classPrivateFieldSet(this, _WorkOrderModel_pm_cycle_start_at, pm_cycle_start_at, "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, Date.now(), "f");
    }
    get pm_cycle_id() {
        return __classPrivateFieldGet(this, _WorkOrderModel_pm_cycle_id, "f");
    }
    set pm_cycle_id(pm_cycle_id) {
        __classPrivateFieldSet(this, _WorkOrderModel_pm_cycle_id, pm_cycle_id, "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, Date.now(), "f");
    }
    get grace_days() {
        return __classPrivateFieldGet(this, _WorkOrderModel_grace_days, "f");
    }
    set grace_days(grace_days) {
        if (grace_days !== null && (typeof grace_days !== 'number' || grace_days < 0)) {
            throw new Error('Grace days must be a non-negative number or null');
        }
        __classPrivateFieldSet(this, _WorkOrderModel_grace_days, grace_days, "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, Date.now(), "f");
    }
    get checklist() {
        return __classPrivateFieldGet(this, _WorkOrderModel_checklist, "f");
    }
    set checklist(checklist) {
        __classPrivateFieldSet(this, _WorkOrderModel_checklist, checklist || [], "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, Date.now(), "f");
    }
    get parts() {
        return __classPrivateFieldGet(this, _WorkOrderModel_parts, "f");
    }
    set parts(parts) {
        __classPrivateFieldSet(this, _WorkOrderModel_parts, parts || [], "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, Date.now(), "f");
    }
    // Static methods
    static get priorityCats() {
        return [
            { cat: WorkOrderPriorityCat.LOW, name: 'Low' },
            { cat: WorkOrderPriorityCat.MEDIUM, name: 'Medium' },
            { cat: WorkOrderPriorityCat.HIGH, name: 'High' },
            { cat: WorkOrderPriorityCat.CRITICAL, name: 'Critical' }
        ];
    }
    static get statusCats() {
        return [
            { cat: WorkOrderStatusCat.OPEN, name: 'Open' },
            { cat: WorkOrderStatusCat.IN_PROGRESS, name: 'In Progress' },
            { cat: WorkOrderStatusCat.COMPLETED, name: 'Completed' },
            { cat: WorkOrderStatusCat.AWAITING_PARTS, name: 'Awaiting Parts' }
        ];
    }
    // Instance methods
    isOpen() {
        return this.status_cat === WorkOrderStatusCat.OPEN;
    }
    isInProgress() {
        return this.status_cat === WorkOrderStatusCat.IN_PROGRESS;
    }
    isCompleted() {
        return this.status_cat === WorkOrderStatusCat.COMPLETED;
    }
    isAwaitingParts() {
        return this.status_cat === WorkOrderStatusCat.AWAITING_PARTS;
    }
    isCritical() {
        return this.priority_cat === WorkOrderPriorityCat.CRITICAL;
    }
    isHighPriority() {
        return this.priority_cat === WorkOrderPriorityCat.HIGH || this.priority_cat === WorkOrderPriorityCat.CRITICAL;
    }
    canBeAssigned() {
        return this.status_cat === WorkOrderStatusCat.OPEN;
    }
    canBeStarted() {
        return this.status_cat === WorkOrderStatusCat.OPEN || this.status_cat === WorkOrderStatusCat.IN_PROGRESS;
    }
    canBeCompleted() {
        return this.status_cat === WorkOrderStatusCat.IN_PROGRESS;
    }
    canBeClosed() {
        return this.status_cat === WorkOrderStatusCat.COMPLETED;
    }
    // Timing helpers
    hasActiveSession() {
        return __classPrivateFieldGet(this, _WorkOrderModel_current_started_at, "f") !== null;
    }
    startWork(now = Date.now()) {
        if (__classPrivateFieldGet(this, _WorkOrderModel_current_started_at, "f") === null) {
            __classPrivateFieldSet(this, _WorkOrderModel_current_started_at, now, "f");
            __classPrivateFieldSet(this, _WorkOrderModel_updated_at, now, "f");
        }
    }
    pauseWork(now = Date.now()) {
        if (__classPrivateFieldGet(this, _WorkOrderModel_current_started_at, "f") !== null) {
            const delta = Math.max(0, now - __classPrivateFieldGet(this, _WorkOrderModel_current_started_at, "f"));
            __classPrivateFieldSet(this, _WorkOrderModel_active_work_ms, Math.max(0, (__classPrivateFieldGet(this, _WorkOrderModel_active_work_ms, "f") || 0) + delta), "f");
            __classPrivateFieldSet(this, _WorkOrderModel_current_started_at, null, "f");
            __classPrivateFieldSet(this, _WorkOrderModel_updated_at, now, "f");
        }
    }
    completeWork(now = Date.now()) {
        // Roll up any active session then mark completed
        this.pauseWork(now);
        __classPrivateFieldSet(this, _WorkOrderModel_completed_at, now, "f");
        __classPrivateFieldSet(this, _WorkOrderModel_status_cat, WorkOrderStatusCat.COMPLETED, "f");
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, now, "f");
    }
    applyStatusTransition(nextStatus, now = Date.now()) {
        const leavingInProgress = __classPrivateFieldGet(this, _WorkOrderModel_status_cat, "f") === WorkOrderStatusCat.IN_PROGRESS && nextStatus !== WorkOrderStatusCat.IN_PROGRESS;
        const enteringInProgress = __classPrivateFieldGet(this, _WorkOrderModel_status_cat, "f") !== WorkOrderStatusCat.IN_PROGRESS && nextStatus === WorkOrderStatusCat.IN_PROGRESS;
        if (leavingInProgress) {
            this.pauseWork(now);
        }
        if (enteringInProgress) {
            this.startWork(now);
        }
        __classPrivateFieldSet(this, _WorkOrderModel_status_cat, nextStatus, "f");
        if (nextStatus === WorkOrderStatusCat.COMPLETED) {
            __classPrivateFieldSet(this, _WorkOrderModel_completed_at, now, "f");
        }
        __classPrivateFieldSet(this, _WorkOrderModel_updated_at, now, "f");
    }
    getLeadTimeMs() {
        if (__classPrivateFieldGet(this, _WorkOrderModel_completed_at, "f") === null)
            return null;
        return Math.max(0, __classPrivateFieldGet(this, _WorkOrderModel_completed_at, "f") - __classPrivateFieldGet(this, _WorkOrderModel_created_at, "f"));
    }
    getWaitingTimeMs() {
        const lead = this.getLeadTimeMs();
        if (lead === null)
            return null;
        return Math.max(0, lead - (__classPrivateFieldGet(this, _WorkOrderModel_active_work_ms, "f") || 0));
    }
    // PM-specific methods
    isPMWorkOrder() {
        return this.is_pm;
    }
    isPMOverdue() {
        if (!this.is_pm || !this.pm_due_at)
            return false;
        return this.pm_due_at < Date.now();
    }
    getPMDaysOverdue() {
        if (!this.isPMOverdue())
            return 0;
        const now = Date.now();
        const diffTime = now - this.pm_due_at;
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }
    getPMDaysUntilDue() {
        if (!this.is_pm || !this.pm_due_at)
            return 0;
        const now = Date.now();
        const diffTime = this.pm_due_at - now;
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }
    // Serialization methods
    toJSON() {
        return {
            company_id: __classPrivateFieldGet(this, _WorkOrderModel_company_id, "f"),
            asset_id: __classPrivateFieldGet(this, _WorkOrderModel_asset_id, "f"),
            description: __classPrivateFieldGet(this, _WorkOrderModel_description, "f"),
            priority_cat: __classPrivateFieldGet(this, _WorkOrderModel_priority_cat, "f"),
            priority: this.priority, // For backward compatibility
            assigned_to: __classPrivateFieldGet(this, _WorkOrderModel_assigned_to, "f"),
            created_by: __classPrivateFieldGet(this, _WorkOrderModel_created_by, "f"),
            status_cat: __classPrivateFieldGet(this, _WorkOrderModel_status_cat, "f"),
            status: this.status, // For backward compatibility
            created_at: __classPrivateFieldGet(this, _WorkOrderModel_created_at, "f"),
            updated_at: __classPrivateFieldGet(this, _WorkOrderModel_updated_at, "f"),
            active_work_ms: __classPrivateFieldGet(this, _WorkOrderModel_active_work_ms, "f"),
            current_started_at: __classPrivateFieldGet(this, _WorkOrderModel_current_started_at, "f"),
            completed_at: __classPrivateFieldGet(this, _WorkOrderModel_completed_at, "f"),
            is_pm: __classPrivateFieldGet(this, _WorkOrderModel_is_pm, "f"),
            pm_template_id: __classPrivateFieldGet(this, _WorkOrderModel_pm_template_id, "f"),
            pm_due_at: __classPrivateFieldGet(this, _WorkOrderModel_pm_due_at, "f"),
            pm_cycle_start_at: __classPrivateFieldGet(this, _WorkOrderModel_pm_cycle_start_at, "f"),
            is_pm_overdue: this.isPMOverdue(),
            pm_days_overdue: this.getPMDaysOverdue(),
            pm_days_until_due: this.getPMDaysUntilDue(),
            work_time_ms: __classPrivateFieldGet(this, _WorkOrderModel_active_work_ms, "f"),
            lead_time_ms: this.getLeadTimeMs(),
            waiting_time_ms: this.getWaitingTimeMs()
        };
    }
    toFirestore() {
        return {
            company_id: __classPrivateFieldGet(this, _WorkOrderModel_company_id, "f"),
            asset_id: __classPrivateFieldGet(this, _WorkOrderModel_asset_id, "f"),
            description: __classPrivateFieldGet(this, _WorkOrderModel_description, "f"),
            priority_cat: __classPrivateFieldGet(this, _WorkOrderModel_priority_cat, "f"),
            priority: this.priority, // For backward compatibility
            assigned_to: __classPrivateFieldGet(this, _WorkOrderModel_assigned_to, "f"),
            created_by: __classPrivateFieldGet(this, _WorkOrderModel_created_by, "f"),
            status_cat: __classPrivateFieldGet(this, _WorkOrderModel_status_cat, "f"),
            status: this.status, // For backward compatibility
            created_at: __classPrivateFieldGet(this, _WorkOrderModel_created_at, "f"),
            updated_at: __classPrivateFieldGet(this, _WorkOrderModel_updated_at, "f"),
            active_work_ms: __classPrivateFieldGet(this, _WorkOrderModel_active_work_ms, "f"),
            current_started_at: __classPrivateFieldGet(this, _WorkOrderModel_current_started_at, "f"),
            completed_at: __classPrivateFieldGet(this, _WorkOrderModel_completed_at, "f"),
            // PM
            is_pm: __classPrivateFieldGet(this, _WorkOrderModel_is_pm, "f"),
            pm_template_id: __classPrivateFieldGet(this, _WorkOrderModel_pm_template_id, "f"),
            pm_due_at: __classPrivateFieldGet(this, _WorkOrderModel_pm_due_at, "f"),
            pm_cycle_start_at: __classPrivateFieldGet(this, _WorkOrderModel_pm_cycle_start_at, "f"),
            pm_cycle_id: __classPrivateFieldGet(this, _WorkOrderModel_pm_cycle_id, "f"),
            grace_days: __classPrivateFieldGet(this, _WorkOrderModel_grace_days, "f"),
            // Snapshots
            checklist: __classPrivateFieldGet(this, _WorkOrderModel_checklist, "f"),
            parts: __classPrivateFieldGet(this, _WorkOrderModel_parts, "f"),
        };
    }
}
_WorkOrderModel_company_id = new WeakMap(), _WorkOrderModel_asset_id = new WeakMap(), _WorkOrderModel_description = new WeakMap(), _WorkOrderModel_priority_cat = new WeakMap(), _WorkOrderModel_assigned_to = new WeakMap(), _WorkOrderModel_status_cat = new WeakMap(), _WorkOrderModel_created_by = new WeakMap(), _WorkOrderModel_created_at = new WeakMap(), _WorkOrderModel_updated_at = new WeakMap(), _WorkOrderModel_active_work_ms = new WeakMap(), _WorkOrderModel_current_started_at = new WeakMap(), _WorkOrderModel_completed_at = new WeakMap(), _WorkOrderModel_is_pm = new WeakMap(), _WorkOrderModel_pm_template_id = new WeakMap(), _WorkOrderModel_pm_due_at = new WeakMap(), _WorkOrderModel_pm_cycle_start_at = new WeakMap(), _WorkOrderModel_pm_cycle_id = new WeakMap(), _WorkOrderModel_grace_days = new WeakMap(), _WorkOrderModel_checklist = new WeakMap(), _WorkOrderModel_parts = new WeakMap();
//# sourceMappingURL=WorkOrderModel.js.map